export default "__VITE_ASSET__Q7Kx9OLI__"